import { render, staticRenderFns } from "./joinus.vue?vue&type=template&id=33583c2e&scoped=true"
import script from "./joinus.vue?vue&type=script&lang=js"
export * from "./joinus.vue?vue&type=script&lang=js"
import style0 from "./joinus.vue?vue&type=style&index=0&id=33583c2e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6.0_webpack@4.47.0__lodash_sniwsisxdvcgzet3yrvlfqnueq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33583c2e",
  null
  
)

export default component.exports